import classnames from 'classnames'
import React,
{
  useEffect,
  useRef,
  useState
} from 'react'
import ReactDOM from 'react-dom'
import { usePopper } from 'react-popper'

import useOutsideClick from 'hooks/useOutsideClick'

import './style.css'

const Flyout = ({
  open,
  trigger,
  target,
  toggle
}) => {
  const innerRef = useRef()
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  const [innerOpen, setInnerOpen] = useState(open)
  useOutsideClick(innerRef, () => toggle(false))

  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement: "bottom-start",
    modifiers: [{
      name: "arrow",
      options: { element: arrowElement }
    },
    {
      name: "offset",
      enabled: true,
      options: { offset: [0, 10] }
    },
    {
      name: 'preventOverflow',
      options: { altBoundary: true }
    }]
  })

  useEffect(() => {
    setTimeout(()=> setInnerOpen(open), 0)
  }, [open])

  return (
    <div className="crm-flyout-wrapper">

      <div ref={setReferenceElement}>
        {trigger()}
      </div>

      {open && ReactDOM.createPortal(<>
          <div
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
          >
            <div
              ref={innerRef}
              className={classnames("crm-flyout", { "crm-flyout--open": innerOpen })}
            >
              {innerOpen && (
              <>
                {target()}
                <div
                  ref={setArrowElement}
                  style={styles.arrow}
                />
              </>
              )}
            </div>
          </div>
                                     </>
      , document.querySelector('#flyout-root'))}
    </div>
  )
}

export default Flyout
